import * as _siweParser2 from "@spruceid/siwe-parser";

var _siweParser = "default" in _siweParser2 ? _siweParser2.default : _siweParser2;

import * as _ethers2 from "ethers";

var _ethers = "default" in _ethers2 ? _ethers2.default : _ethers2;

import * as _validUrl2 from "valid-url";

var _validUrl = "default" in _validUrl2 ? _validUrl2.default : _validUrl2;

import _types from "./types";
import _utils from "./utils";
var exports = {};

var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = exports && exports.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiweMessage = void 0; // TODO: Figure out how to get types from this lib:

const siwe_parser_1 = _siweParser;
const ethers_1 = _ethers;

const uri = __importStar(_validUrl);

const types_1 = _types;
const utils_1 = _utils;

class SiweMessage {
  /**
   * Creates a parsed Sign-In with Ethereum Message (EIP-4361) object from a
   * string or an object. If a string is used an ABNF parser is called to
   * validate the parameter, otherwise the fields are attributed.
   * @param param {string | SiweMessage} Sign message as a string or an object.
   */
  constructor(param) {
    if (typeof param === "string") {
      const parsedMessage = new siwe_parser_1.ParsedMessage(param);
      this.domain = parsedMessage.domain;
      this.address = parsedMessage.address;
      this.statement = parsedMessage.statement;
      this.uri = parsedMessage.uri;
      this.version = parsedMessage.version;
      this.nonce = parsedMessage.nonce;
      this.issuedAt = parsedMessage.issuedAt;
      this.expirationTime = parsedMessage.expirationTime;
      this.notBefore = parsedMessage.notBefore;
      this.requestId = parsedMessage.requestId;
      this.chainId = parsedMessage.chainId;
      this.resources = parsedMessage.resources;
    } else {
      Object.assign(this, param);

      if (typeof this.chainId === "string") {
        this.chainId = parseInt(this.chainId);
      }
    }

    this.validate();
  }
  /**
   * Given a sign message (EIP-4361) returns the correct matching groups.
   * @param message {string}
   * @returns {RegExpExecArray} The matching groups for the message
   */


  regexFromMessage(message) {
    const parsedMessage = new siwe_parser_1.ParsedMessageRegExp(message);
    return parsedMessage.match;
  }
  /**
   * This function can be used to retrieve an EIP-4361 formated message for
   * signature, although you can call it directly it's advised to use
   * [prepareMessage()] instead which will resolve to the correct method based
   * on the [type] attribute of this object, in case of other formats being
   * implemented.
   * @returns {string} EIP-4361 formated message, ready for EIP-191 signing.
   */


  toMessage() {
    /** Validates all fields of the object */
    this.validate();
    const header = `${this.domain} wants you to sign in with your Ethereum account:`;
    const uriField = `URI: ${this.uri}`;
    let prefix = [header, this.address].join("\n");
    const versionField = `Version: ${this.version}`;

    if (!this.nonce) {
      this.nonce = (0, utils_1.generateNonce)();
    }

    const chainField = `Chain ID: ` + this.chainId || "1";
    const nonceField = `Nonce: ${this.nonce}`;
    const suffixArray = [uriField, versionField, chainField, nonceField];

    if (this.issuedAt) {
      Date.parse(this.issuedAt);
    }

    this.issuedAt = this.issuedAt ? this.issuedAt : new Date().toISOString();
    suffixArray.push(`Issued At: ${this.issuedAt}`);

    if (this.expirationTime) {
      const expiryField = `Expiration Time: ${this.expirationTime}`;
      suffixArray.push(expiryField);
    }

    if (this.notBefore) {
      suffixArray.push(`Not Before: ${this.notBefore}`);
    }

    if (this.requestId) {
      suffixArray.push(`Request ID: ${this.requestId}`);
    }

    if (this.resources) {
      suffixArray.push([`Resources:`, ...this.resources.map(x => `- ${x}`)].join("\n"));
    }

    let suffix = suffixArray.join("\n");
    prefix = [prefix, this.statement].join("\n\n");

    if (this.statement) {
      prefix += "\n";
    }

    return [prefix, suffix].join("\n");
  }
  /**
   * This method parses all the fields in the object and creates a sign
   * message according with the type defined.
   * @returns {string} Returns a message ready to be signed according with the
   * type defined in the object.
   */


  prepareMessage() {
    let message;

    switch (this.version) {
      case "1":
        {
          message = this.toMessage();
          break;
        }

      default:
        {
          message = this.toMessage();
          break;
        }
    }

    return message;
  }
  /**
   * Validates the integrity of the object by matching it's signature.
   * @param params Parameters to verify the integrity of the message, signature is required.
   * @returns {Promise<SiweMessage>} This object if valid.
   */


  verify(params, provider) {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise(resolve => __awaiter(this, void 0, void 0, function* () {
        const {
          signature,
          domain,
          nonce,
          time
        } = params;
        /** Domain binding */

        if (domain && domain !== this.domain) {
          resolve({
            success: false,
            data: this,
            error: new types_1.SiweError(types_1.SiweErrorType.DOMAIN_MISMATCH, domain, this.domain)
          });
        }
        /** Nonce binding */


        if (nonce && nonce !== this.nonce) {
          resolve({
            success: false,
            data: this,
            error: new types_1.SiweError(types_1.SiweErrorType.NONCE_MISMATCH, nonce, this.nonce)
          });
        }
        /** Check time or now */


        const checkTime = new Date(time || new Date());
        /** Message not expired */

        if (this.expirationTime) {
          const expirationDate = new Date(this.expirationTime);

          if (checkTime.getTime() >= expirationDate.getTime()) {
            resolve({
              success: false,
              data: this,
              error: new types_1.SiweError(types_1.SiweErrorType.EXPIRED_MESSAGE, `${checkTime.toISOString()} < ${expirationDate.toISOString()}`, `${checkTime.toISOString()} >= ${expirationDate.toISOString()}`)
            });
          }
        }
        /** Message is valid already */


        if (this.notBefore) {
          const notBefore = new Date(this.notBefore);

          if (checkTime.getTime() < notBefore.getTime()) {
            resolve({
              success: false,
              data: this,
              error: new types_1.SiweError(types_1.SiweErrorType.EXPIRED_MESSAGE, `${checkTime.toISOString()} >= ${notBefore.toISOString()}`, `${checkTime.toISOString()} < ${notBefore.toISOString()}`)
            });
          }
        }

        let EIP4361Message;

        try {
          EIP4361Message = this.prepareMessage();
        } catch (e) {
          resolve({
            success: false,
            data: this,
            error: e
          });
        }
        /** Recover address from signature */


        let addr;

        try {
          addr = ethers_1.utils.verifyMessage(EIP4361Message, signature);
        } catch (_) {} finally {
          /** Match signature with message's address */
          if (addr !== this.address) {
            let isValid = false;

            try {
              /** Try resolving EIP-1271 if address doesn't match */
              isValid = yield (0, utils_1.checkContractWalletSignature)(this, signature, provider);
            } catch (_) {
              isValid = false;
            } finally {
              if (!isValid) {
                resolve({
                  success: false,
                  data: this,
                  error: new types_1.SiweError(types_1.SiweErrorType.INVALID_SIGNATURE, addr, `Resolved address to be ${this.address}`)
                });
              }
            }
          }
        }

        resolve({
          success: true,
          data: this
        });
      }));
    });
  }
  /**
   * Validates the value of this object fields.
   * @throws Throws an {ErrorType} if a field is invalid.
   */


  validate() {
    /** `domain` check. */
    if (this.domain.length === 0 || !/[^#?]*/.test(this.domain)) {
      throw new types_1.SiweError(types_1.SiweErrorType.INVALID_DOMAIN, `${this.domain} to be a valid domain.`);
    }
    /** EIP-55 `address` check. */


    if (!(0, siwe_parser_1.isEIP55Address)(this.address)) {
      throw new types_1.SiweError(types_1.SiweErrorType.INVALID_ADDRESS, ethers_1.utils.getAddress(this.address), this.address);
    }
    /** Check if the URI is valid. */


    if (!uri.isUri(this.uri)) {
      throw new types_1.SiweError(types_1.SiweErrorType.INVALID_URI, `${this.uri} to be a valid uri.`);
    }
    /** Check if the version is 1. */


    if (this.version !== "1") {
      throw new types_1.SiweError(types_1.SiweErrorType.INVALID_MESSAGE_VERSION, "1", this.version);
    }
    /** Check if the nonce is alphanumeric and bigger then 8 characters */


    const nonce = this.nonce.match(/[a-zA-Z0-9]{8,}/);

    if (!nonce || this.nonce.length < 8 || nonce[0] !== this.nonce) {
      throw new types_1.SiweError(types_1.SiweErrorType.INVALID_NONCE, `Length > 8 (${nonce.length}). Alphanumeric.`, this.nonce);
    }

    const ISO8601 = /([0-9]+)-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])[Tt]([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60)(\.[0-9]+)?(([Zz])|([+|\-]([01][0-9]|2[0-3]):[0-5][0-9]))/;
    /** `issuedAt` conforms to ISO-8601 */

    if (this.issuedAt) {
      if (!ISO8601.test(this.issuedAt)) {
        throw new Error(types_1.SiweErrorType.INVALID_TIME_FORMAT);
      }
    }
    /** `expirationTime` conforms to ISO-8601 */


    if (this.expirationTime) {
      if (!ISO8601.test(this.expirationTime)) {
        throw new Error(types_1.SiweErrorType.INVALID_TIME_FORMAT);
      }
    }
    /** `notBefore` conforms to ISO-8601 */


    if (this.notBefore) {
      if (!ISO8601.test(this.notBefore)) {
        throw new Error(types_1.SiweErrorType.INVALID_TIME_FORMAT);
      }
    }
  }

}

exports.SiweMessage = SiweMessage;
export default exports;